import React, { useState } from 'react';
import {
    Card, Button, Snackbar, CircularProgress
} from '@material-ui/core';
import axiosWithAuthInterceptor from '../util/axiosWithAuthInterceptor';

export function TaraSendBulk() {
    const [file, setFile] = useState<File | null>(null); 
    const [loading, setLoading] = useState(false); 
    const [error, setError] = useState<String | null>(null); 
    const handleFileChange = (event:any) => {
        setFile(event.target.files[0]);
    };

    const handleFileSubmit = async () => {
        setLoading(true); 
        try {
            const formData = new FormData();
            if (file) {
                console.log("ishere");
                
                formData.append('file', file); 
                const response = await axiosWithAuthInterceptor.post(
                    `https://test2.ringel.co/lemonade/api/tara/send/bulk`,
                    formData,
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                        }
                    }
                );
                console.log('Response:', response.data);
                if (response.data && response.data.count) {
                    setFile(null)
                    setError(`تعداد ${response.data.count} رکورد با موفقیت ثبت شد `)
                    setLoading(false);
     
                }
                if (response.data && response.data.err) {
                    setFile(null)
                    setError(`خطایی پیش آمده است لطفا مجدد تلاش کنید`)
                    setLoading(false);
             
                }
           
            }
           
        } catch (error) {
            console.error('Error:', error);
            setError('ارسال فایل ناموفق بود'); 
        } finally {
            setLoading(false); 
        }
    };

    return (
        <Card style={{marginTop:"20px"}}>
            <div style={{display:"flex", flexDirection:"row"}}>

            <div style={{margin:"2rem"}}>
            <input
                accept=".csv"
                id="contained-button-file"
                multiple
                type="file"
                style={{ display: 'none' }}
                onChange={handleFileChange}
            />
            <label htmlFor="contained-button-file">
                <Button variant="contained" color="primary" component="span">
                    انتخاب فایل csv
                </Button>
            </label>
      

            </div>
            <div style={{margin:"2rem"}}>
                  <Button
                variant="contained"
                color="primary"
                onClick={handleFileSubmit}
                disabled={!file || loading} 
            >
                {loading ? <CircularProgress size={24} /> : ' ارسال'}
            </Button>
            </div>
            </div>
 
            

            <Snackbar
                open={!!error}
                autoHideDuration={6000}
                onClose={() => setError('')}
                message={error}
            />
        </Card>
    );
}